import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { caseStudies } from '../data/CaseStudyData';
import { industryWorks } from '../data/IndustryWorkData';
const ProductDeepDives = () => {
  return <div className="bg-gray-900 text-white" data-id="element-614">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24" data-id="element-615">
        <div className="text-center mb-16" data-id="element-616">
          <h1 className="text-4xl font-extrabold text-white sm:text-5xl sm:tracking-tight" data-id="element-617">
            Product Deep Dives
          </h1>
          <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-300" data-id="element-618">
            I love dissecting products to understand what makes them click —
            from user needs to business levers and everything in between.
          </p>
        </div>

        {/* Industry Work Section */}
        <section className="mb-20" data-id="element-619">
          <div className="mb-8" data-id="element-620">
            <h2 className="text-3xl font-bold text-white mb-2" data-id="element-621">
              Industry Work
            </h2>
            <p className="text-gray-400" data-id="element-622">
              Real-world product challenges and solutions from my professional
              experience
            </p>
          </div>

          <div className="grid grid-cols-1 gap-6" data-id="element-623">
            {industryWorks.map(work => <Link key={work.id} to={`/industry-work/${work.id}`} className="group" data-id="element-624">
                <div className="relative overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 bg-gradient-to-r from-gray-800 to-gray-900 border border-gray-700" data-id="element-625">
                  <div className="p-6 flex flex-col md:flex-row gap-6 items-center" data-id="element-626">
                    <div className="w-full md:w-[80px]" data-id="element-627">
                      <div className="w-[80px] h-[80px] rounded-lg overflow-hidden bg-white p-2" data-id="element-628">
                        <img src={work.imageUrl} alt={work.company} className="w-full h-full object-contain transform group-hover:scale-105 transition-transform duration-300" data-id="element-629" />
                      </div>
                    </div>
                    <div className="w-full md:flex-1" data-id="element-630">
                      <div className="flex items-center mb-2" data-id="element-631">
                        <span className="text-xs font-semibold text-indigo-400 bg-indigo-900/50 px-2 py-0.5 rounded-full" data-id="element-632">
                          {work.company}
                        </span>
                      </div>
                      <h2 className="text-xl font-bold text-white group-hover:text-indigo-400 transition-colors" data-id="element-633">
                        {work.title}
                      </h2>
                      <div className="mt-2 flex flex-wrap gap-2" data-id="element-634">
                        {work.tags.slice(0, 4).map((tag, i) => <span key={i} className="bg-gray-700 text-gray-300 text-xs px-2 py-0.5 rounded-full" data-id="element-635">
                            {tag}
                          </span>)}
                      </div>
                      <div className="mt-4 flex items-center text-indigo-400 group-hover:text-indigo-300 font-medium text-sm" data-id="element-636">
                        View Full Case Study
                        <ArrowRightIcon className="ml-1 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-637" />
                      </div>
                    </div>
                  </div>
                </div>
              </Link>)}
          </div>
        </section>

        {/* Exploration Work Section */}
        <section data-id="element-638">
          <div className="mb-8" data-id="element-639">
            <h2 className="text-3xl font-bold text-white mb-2" data-id="element-640">
              Exploration Work
            </h2>
            <p className="text-gray-400" data-id="element-641">
              Personal explorations and analysis of existing products
            </p>
          </div>
          <div className="grid grid-cols-1 gap-6" data-id="element-642">
            {caseStudies.map((caseStudy, index) => <Link key={caseStudy.id} to={`/case-study/${caseStudy.id}`} className="group" data-id="element-643">
                <div className="relative overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 bg-gradient-to-r from-gray-800 to-gray-900 border border-gray-700" data-id="element-644">
                  <div className="p-6 flex flex-col md:flex-row gap-6 items-center" data-id="element-645">
                    <div className="w-full md:w-[80px]" data-id="element-646">
                      <div className="w-[80px] h-[80px] rounded-lg overflow-hidden" data-id="element-647">
                        <img src={caseStudy.imageUrl} alt={caseStudy.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-300" data-id="element-648" />
                      </div>
                    </div>
                    <div className="w-full md:flex-1" data-id="element-649">
                      <div className="flex items-center mb-2" data-id="element-650">
                        <span className="text-xs font-semibold text-indigo-400 bg-indigo-900/50 px-2 py-0.5 rounded-full" data-id="element-651">
                          Case Study {index + 1}
                        </span>
                        <span className="ml-3 text-xs text-gray-400" data-id="element-652">
                          {caseStudy.company}
                        </span>
                      </div>
                      <h2 className="text-xl font-bold text-white group-hover:text-indigo-400 transition-colors" data-id="element-653">
                        {caseStudy.title}
                      </h2>
                      <div className="mt-2 flex flex-wrap gap-2" data-id="element-654">
                        {caseStudy.tags.slice(0, 3).map((tag, i) => <span key={i} className="bg-gray-700 text-gray-300 text-xs px-2 py-0.5 rounded-full" data-id="element-655">
                            {tag}
                          </span>)}
                      </div>
                      <div className="mt-4 flex items-center text-indigo-400 group-hover:text-indigo-300 font-medium text-sm" data-id="element-656">
                        Read Case Study
                        <ArrowRightIcon className="ml-1 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-657" />
                      </div>
                    </div>
                  </div>
                </div>
              </Link>)}
          </div>
        </section>
      </div>
    </div>;
};
export default ProductDeepDives;